import * as React from 'react';
import {useRef, useState, useEffect} from 'react';
import { InputStyle } from './style';
import './index.scss';

interface IProps {
    isReadOnly?: boolean;
    isRequired?: boolean;
    validated?: 'success' | 'warning' | 'error' | 'default';
    type: string;
    placeholder?: string;
    value?: string | number;
    fieldName: string;
    onChange: (fieldName: string, value: string| number, event?: React.FormEvent<HTMLInputElement>) => void;
    handleBlur?: (value: string | number) => void;
    label?: string;
    tooltipLabel?: string;
    index?: number;
    min?: number | string;
    max?: number | string;
    errorMsg?: string;
    disabled?: boolean;
    regex?: string;
    url?: string;
    styleType?: string;
}

enum STYLETYPE {
  ROUNDED_INPUT = 'rounded',
  BORDER_BOTTOM_INPUT = 'line'
}

export const TextField = (props: IProps) => {
    const inputRef = useRef(null);
    const [focus, changeFocus] = useState(false);
    
    const handleBlur = (event: React.FormEvent<HTMLInputElement>) => {
      if (props.handleBlur) {
        props.handleBlur(event.currentTarget.value);
      }
      changeFocus(false);
    };
    return (
        <div className={`text-field-container`}>
            <div className="label-wrapper">
            {props.label ?
                <div className="label">
                    {props.label}
                </div> : null}
                {!props.isRequired && <span className="form-optional">Optional</span>}
                {props.tooltipLabel && 
                  <div className="form-tooltip">
                    <span className="form-tooltiptext form-tooltip-right">{props.tooltipLabel}</span>
                  </div>
                }
            </div>
            <div className={`text-field flex-center-row ${focus ? " active" : ""}`}>
                <input
                    id={props.fieldName}
                    className = {
                    `${
                      props.index === 0 || props.index ? 's-form-input': ''} ${
                      props.type === 'date' ? 's-form-date': ''} ${
                      props.validated === 'error' ? 's-form-invalid': ''} ${
                      props.validated === 'success' ? 's-form-success': ''} ${
                      props.validated === 'warning' ? 's-form-warning': ''}`
                    }
                    style={STYLETYPE.BORDER_BOTTOM_INPUT === props.styleType ?
                        focus ? {...InputStyle.lineStyle['default'], ...InputStyle.lineStyle['focus']} : InputStyle.lineStyle['default']:
                     STYLETYPE.ROUNDED_INPUT === props.styleType? focus ? {...InputStyle.roundedStyle['default'], ...InputStyle.roundedStyle['focus']} : InputStyle.roundedStyle['default']: {}}
                    ref={inputRef}
                    type={props.type}
                    placeholder={props.placeholder}
                    value={props.value !== null ? props.value : ''}
                    min={props.min}
                    max={props.max}
                    maxLength={props.max && typeof props.max === 'number' ? Number(props.max): null}
                    minLength={props.min && typeof props.min === 'number' ? Number(props.min): null}
                    disabled={props.disabled}
                    readOnly={props.isReadOnly}
                    required={props.isRequired}
                    aria-invalid={props.validated === 'error'}
                    onChange={(event) => props.onChange(props.fieldName, event.currentTarget.value, event)}
                    onFocus={() => changeFocus(true)}
                    onBlur={handleBlur}
                    onKeyPress={(event) => {if (props.type === 'number' && props.max && (event.currentTarget.value.length > Number(props.max) - 1)) { event.preventDefault(); return false;} }}
                />
            </div>
            {props.errorMsg ?
                <div className="error-message flex-center-row">
                    {props.errorMsg}
                </div> : null}
        </div>
    );
};

TextField.defaultProps = {
  isRequired: true,
}

export default TextField;
